import { QueryOptions } from 'react-query';

import { getCartItemsCount } from '../graphql/select-option.2';

import { IncomingMessage } from 'http';

type Request = IncomingMessage;
export const cartCountQueryOption = (req?: Request): QueryOptions<number, unknown, number, 'getCartItemsCount'> => ({
  queryFn: async () => {
    const result = await getCartItemsCount(
      undefined,
      req ? { context: req, show_alert: false } : { show_alert: false },
    );
    return result.data.cart_items_count;
  },
  queryKey: 'getCartItemsCount',
});
